/**
 * Star-rating widget for the "Bewertung" flexible-content layout
 * (template-parts/bewertung.php). Markup order is 1..5 left to right,
 * matching visual and tab order (WCAG 2.4.3), so "this star + every one
 * before it" is just "every star at or before this index" - handled here
 * via .bewertungStarActive instead of a CSS-only sibling trick, so mouse,
 * touch and keyboard focus all get the identical preview (css/templates/
 * _bewertung.scss reads the class, not :hover, for the filled icon).
 *
 * Clicking (mouse, touch, or Enter/Space via native <button> behaviour)
 * redirects: 4-5 stars goes to the "hohe Bewertung" link, 1-3 to "niedrige
 * Bewertung", both read from data attributes on the .bewertungStars wrapper.
 */

function lhmSetBewertungActive(stars, activeIndex) {
    stars.forEach((star, i) => {
        star.classList.toggle('bewertungStarActive', activeIndex !== -1 && i <= activeIndex);
    });
}

function lhmInitBewertungStars(wrapper) {
    const stars = Array.from(wrapper.querySelectorAll('.bewertungStar'));
    if (stars.length === 0) {
        return;
    }

    stars.forEach((star, index) => {
        star.addEventListener('mouseenter', () => lhmSetBewertungActive(stars, index));
        star.addEventListener('focus', () => lhmSetBewertungActive(stars, index));
        star.addEventListener('mouseleave', () => lhmSetBewertungActive(stars, -1));
        star.addEventListener('blur', () => lhmSetBewertungActive(stars, -1));

        star.addEventListener('click', () => {
            const rating = parseInt(star.getAttribute('data-rating'), 10);
            const isTopRating = rating >= 4;

            const url = isTopRating ? wrapper.getAttribute('data-url-hoch') : wrapper.getAttribute('data-url-niedrig');
            const target = isTopRating ? wrapper.getAttribute('data-target-hoch') : wrapper.getAttribute('data-target-niedrig');

            if (!url) {
                return;
            }

            if (target === '_blank') {
                window.open(url, '_blank', 'noopener');
            } else {
                window.location.href = url;
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.bewertungStars').forEach(lhmInitBewertungStars);
});
